
import { supabase } from "@/integrations/supabase/client";

export const uploadFile = async (file: File, folder: string): Promise<string | null> => {
  const fileExt = file.name.split('.').pop();
  const fileName = `${Math.random().toString(36).substring(2, 15)}.${fileExt}`;
  const filePath = `${folder}/${fileName}`;

  const { error: uploadError } = await supabase.storage
    .from('crime-evidence')
    .upload(filePath, file);

  if (uploadError) {
    console.error('Error uploading file:', uploadError);
    return null;
  }

  return filePath;
};

export const uploadAllFiles = async (
  imageFiles: File[], 
  videoFiles: File[],
  onProgress: (progress: number) => void
) => {
  const totalFiles = imageFiles.length + videoFiles.length;
  if (totalFiles === 0) return { images: [], videos: [] };

  const fileResults = {
    images: [] as string[],
    videos: [] as string[],
  };

  let filesProcessed = 0;

  for (const file of imageFiles) {
    const filePath = await uploadFile(file, 'images');
    if (filePath) fileResults.images.push(filePath);
    filesProcessed++;
    onProgress(Math.round((filesProcessed / totalFiles) * 100));
  }

  for (const file of videoFiles) {
    const filePath = await uploadFile(file, 'videos');
    if (filePath) fileResults.videos.push(filePath);
    filesProcessed++;
    onProgress(Math.round((filesProcessed / totalFiles) * 100));
  }

  return fileResults;
};
